import { RESET_FORM } from '../actionTypes';
import { actions } from '../reducer';

export default () => actions[RESET_FORM]();
